import { useAuth } from '../../context/UseAuth';
// --- INICIO DE LA MODIFICACIÓN 1: Importar hooks necesarios ---
import React, { useEffect } from 'react';
import { useLangNavigate } from '../../hooks/useLangNavigate';
import Spinner from '../layout/Spinner';
// --- FIN DE LA MODIFICACIÓN 1 ---

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  // --- INICIO DE LA MODIFICACIÓN 2: Usar el hook de navegación ---
  const langNavigate = useLangNavigate();
  // --- FIN DE LA MODIFICACIÓN 2 ---

  // --- INICIO DE LA MODIFICACIÓN 3: Lógica de redirección segura con useEffect ---
  useEffect(() => {
    // Si no está cargando y el usuario no existe o no es admin, redirigimos.
    if (!loading && (!user || user.profileType !== 'admin')) {
      // Redirigimos a la página de inicio con el prefijo de idioma.
      langNavigate('/', { replace: true });
    }
  }, [loading, user, langNavigate]);
  // --- FIN DE LA MODIFICACIÓN 3 ---

  // Mientras carga o si no es admin (y está a punto de ser redirigido), mostramos un spinner.
  if (loading || !user || user.profileType !== 'admin') {
    return <Spinner fullScreen={true} />;
  }

  // Si el usuario es admin, renderiza el contenido protegido.
  return children;
};

export default AdminRoute;
